import React, { useState, useEffect } from "react";

interface AutoSaveIndicatorProps {
  status?: "idle" | "saving" | "saved";
  isVisible?: boolean;
  className?: string;
}

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  status = "idle",
  isVisible = true,
  className = "",
}) => {
  const [showSaved, setShowSaved] = useState(false);

  // Handle saved status display
  useEffect(() => {
    if (status === "saved") {
      setShowSaved(true);

      // Hide saved indicator after 2 seconds
      const hideTimeout = setTimeout(() => {
        setShowSaved(false);
      }, 2000);

      return () => clearTimeout(hideTimeout);
    }
  }, [status]);

  if (!isVisible) return null;

  return (
    <div className={`autosave-indicator ${className}`}>
      {status === "saving" && (
        <div className="autosave-saving">
          <div className="autosave-dot"></div>
          <span className="autosave-text">Saving...</span>
        </div>
      )}
      {status === "saved" && showSaved && (
        <div className="autosave-saved">
          <div className="autosave-checkmark">✓</div>
          <span className="autosave-text">Saved</span>
        </div>
      )}
    </div>
  );
};
